export function getEnvFromUrl() {
  const { origin } = window.location;

  const isDev =
    origin.includes('portal-trabalhador-dev.vr.com.br') ||
    origin.includes('vocedsp.caixaprepagos.com.br');

  const isQa =
    origin.includes('portal-trabalhador-qa.vr.com.br') ||
    origin.includes('vocehmp.caixaprepagos.com.br');

  const isDynatrace = origin.includes('portal-dynatrace.vr.com.br');

  const isProd =
    origin.includes('portal-trabalhador.vr.com.br') ||
    origin.includes('voce.caixaprepagos.com.br') ||
    isDynatrace;

  return { isDev, isQa, isProd, isDynatrace };
}

export default function getEnv(context) {
  let url = `http://localhost:3000/${context}`;
  const { origin } = window.location;
  const { isDev, isQa, isProd, isDynatrace } = getEnvFromUrl();

  /**
   * Configurando URL das etapas de login
   * As URLs são excessão pois se comunicam direto com a Sensedia, e não com um BFF.
   * */
  function setUrlLoginFlow(env = '') {
    let urlLoginFlow = '';
    if (!origin.includes('http://localhost:3000')) {
      if (context === 'auth-code') {
        urlLoginFlow = `https://api${env}.vr.com.br/oauth/grant-code`;
      }
      if (context === 'access-token') {
        urlLoginFlow = `https://api${env}.vr.com.br/oauth/access-token`;
      }
      if (context === 'auth-user') {
        urlLoginFlow = `https://api${env}.vr.com.br/autenticacao-usuario-rhsso/v3/access-token`;
      }
    }

    return urlLoginFlow;
  }

  /**
   * Configurando URLs dos BFFs
   * */
  if (isDev) {
    url =
      setUrlLoginFlow('-dsp') ||
      `https://pt-bff-${context}-portal-trabalhador-dev.stg.vrbeneficios.io`;
  }

  if (isQa) {
    url =
      setUrlLoginFlow('-hmp') ||
      `https://pt-bff-${context}-portal-trabalhador-qa.stg.vrbeneficios.io`;
  }

  if (isProd || isDynatrace) {
    url =
      setUrlLoginFlow() ||
      `https://pt-bff-${context}-portal-trabalhador-prd.vr.com.br`;
  }

  return url;
}
